export default __webpack_public_path__ + "static/media/downArrowIcon.1fdd7bea.svg";